<template>
    <div class="message-info">
        <mt-header fixed title="消息详情">
            <router-link slot="left" to>
                <mt-button icon="back"  @click="$router.back(-1)">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mt-field label="消息标题"  v-model="title" readonly></mt-field>
            <mt-field label="发件人"  v-model="sender" readonly></mt-field>
            <mt-field label="重要性"  v-model="importance_name[importance]" readonly></mt-field>
            <mt-field label="消息内容" type="textarea" rows="4" v-model="content" readonly></mt-field>
            <mt-field label="发送时间"  v-model="created_at" readonly></mt-field>
            <div class="new-form-button" v-if="url!==null">
                <mt-button size="large" type="primary" @click="enterUrl(url)">跳转处理</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                id:this.$route.params.id,
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                title:'',
                sender:'',
                content:'',
                created_at:'',
                url:null,
                importance:0,
                importance_name:['一般','重要','紧急']
            }
        },

        mounted(){
            this.$axios.get('/message/detail?openid='+this.openid+'&message='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {
                        let r = data.data.data;
                        this.title = r.title;
                        this.sender = r.sender;
                        this.content = r.content;
                        this.created_at = r.created_at;
                        this.importance = r.importance;
                        this.url = r.url;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        },

        methods:{
            enterUrl(url){
                this.$router.push(url);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/message/messageInfo.vue